import React, { useState } from "react";
import { TpaDetailInputWrapper } from "components/Flex/styles";
import { OuterBox } from "./styles";
import { BaseInput, BaseDropdown, LargeButton, Ptag } from "components/core";
import { colors } from "theme";
import { FieldArray } from "formik";
import { Divider } from "@mui/material";
import { Checkbox, FormControlLabel } from "@mui/material";

const DiseaseWiseLimit = ({ formikProps, dropDownValues }) => {
  const [referDefault, setDefault] = useState(false)
  const addMore = (push) => {
    if (
      formikProps.values.disease_wise_limit_detail.length ===
      dropDownValues.length
    ) {
      return;
    }
    push({
      disease_name: "",
      disease_eligibility_criteria: "",
      disease_limit: "",
    });
  };

  const getDropdown = (values, index) => {
    const updatedDropdown = dropDownValues.filter((item) => {
      return !values.disease_wise_limit_detail.some((disease, idx) => {
        // ignoring the current index
        if (index === idx) return false;
        return disease.disease_name === item.value;
      });
    });
    return updatedDropdown;
  };
  const handleChange = () => {
    setDefault(prevVal => !prevVal)
    const prevArray = formikProps.values.disease_wise_limit_detail
    const nullArray = prevArray.length && prevArray.reduce((acc, field)=>{
      acc.push({
        disease_name: "",
        disease_eligibility_criteria: "",
        disease_limit: "",
      })
      return acc
    }, [])
    formikProps.setFieldValue('disease_wise_refer_policydoc', null)
    formikProps.setFieldValue("disease_wise_limit_detail", nullArray)
  }

  return (
    <OuterBox>
      <FormControlLabel
        required
        control={<Checkbox sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }} onChange={()=>handleChange()}/>}
        label={
          <Ptag fontSize='16px' fontWeight='600'>Please Refer Policy Document</Ptag>
        }
      />
      <FieldArray name="disease_wise_limit_detail">
        {({ push }) => (
          <>
            <section
              style={{
                marginBottom: "2rem",
              }}
            >
              {formikProps.values.disease_wise_limit_detail.map(
                (item, index) => {
                  return (
                    <>
                      <section>
                        <div style={{ marginBottom: "2rem" }}>
                          <div style={{ marginTop: "4px" }}>
                            <BaseDropdown
                              label="Name"
                              disabled={referDefault}
                              variant="standard"
                              fontSize="14"
                              options={getDropdown(formikProps.values, index)}
                              formikProps={{
                                ...formikProps,
                                name: `disease_wise_limit_detail[${index}]disease_name`,
                              }}
                            />
                          </div>
                          <TpaDetailInputWrapper marginTop="12px">
                            <BaseInput
                              // formatToRupee
                              disabled={referDefault}
                              customValue={`disease_wise_limit_detail[${index}]['remarks']`}
                              label="Remarks"
                              fontSize="16px !imortant"
                              variant="standard"
                              formikProps={{
                                ...formikProps,
                                name: `disease_wise_limit_detail[${index}]remarks`,
                              }}
                            />
                            <BaseInput
                              formatToRupee
                              customValue={`disease_wise_limit_detail[${index}]['disease_limit']`}
                              disabled={referDefault}
                              label="Limit"
                              fontSize="16px !imortant"
                              variant="standard"
                              formikProps={{
                                ...formikProps,
                                name: `disease_wise_limit_detail[${index}]disease_limit`,
                              }}
                            />
                          </TpaDetailInputWrapper>
                        </div>
                        {index <
                          formikProps.values.disease_wise_limit_detail.length -
                            1 && (
                          <Divider
                            sx={{
                              marginTop: "4rem",
                              marginBottom: "2.6rem",
                              borderColor: "#9e9e9e",
                            }}
                          />
                        )}
                      </section>
                    </>
                  );
                }
              )}
            </section>
            <footer
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <LargeButton
                label="Add More"
                onClick={() => addMore(push)}
                style={{
                  backgroundColor: colors.accentColor,
                  width: "120px",
                  borderRadius: "4px",
                  padding: "10px",
                  marginTop: "2.2rem",
                }}
              />
            </footer>
          </>
        )}
      </FieldArray>
    </OuterBox>
  );
};

export default DiseaseWiseLimit;
